import { TextInput } from 'react-native';
import { colors } from './colors';

export const PLACEHOLDER_TEXT_COLOR = colors.text.placeholder;

let applied = false;

/** Ensures all TextInputs use a light placeholder color unless overridden. */
export function applyTextInputDefaults() {
  if (applied) return;
  applied = true;
  const existing = TextInput.defaultProps ?? {};
  TextInput.defaultProps = {
    ...existing,
    placeholderTextColor: PLACEHOLDER_TEXT_COLOR,
  };
}
